<template>
	<div>
		<v-row>
			<v-col>
				<v-simple-table>
					<thead>
						<tr>
							<th>Item</th>
							<th>Units</th>
							<th>Cost Per Unit</th>
							<th>Total</th>
						</tr>
					</thead>
					<tbody>
						<tr v-for="(row, index) in rows" :key="index">
							<td>{{row.item}}</td>
							<td>{{row.n}}</td>
							<td>£{{row.cpu}}</td>
							<td>£{{row.total}}</td>
						</tr>
					</tbody>
				</v-simple-table>
			</v-col>
		</v-row>
		<v-row v-if="contract">
			<v-col>
				<v-alert  class="ma-5" color="grey lighten-3" dense>{{contract.blurb}}</v-alert>
			</v-col>
		</v-row>
		<v-row>
			<v-col>
				<export-excel
					:data="rows"
					:title="title"
					:fields="columns"
					:footer="footer"
					:name="request.reference">
					<v-btn class="mt-3" color="accent">Download</v-btn>
				</export-excel>
			</v-col>
		</v-row>
	</div>
</template>

<script>
	import Vue from "vue";

	import excel from 'vue-excel-export'
	Vue.use(excel)

	export default {
		name: "Quote", 
		props: {
			request: {type: Object},
			contract: {type: Object}
		},
		computed: {
			title(){
				return this.request.title + " - Meisterworks Quote";
			},
			footer(){
				let footer = "Costs are denominated in " + this.request.currency + ". ";
				if( this.contract ){
					footer += this.contract.blurb;
				}
				return footer;
			},
			columns(){
				return {
					"Item": "item",
					"Units": "n",
					"Cost Per Unit": "cpu",
					"Total": "total",
				}
			},
			rows(){
				var rows = [];
				var row;
				this.request.segments.forEach( segment => {
					if( segment.recruitment ){
						row = {
							item: segment.title + "- Recruitment",
							n: segment.numberOfParticipants * segment.numberOfSessions,
							cpu: segment.recruitment
						};
						rows.push(row)
					}
					if( segment.incentive ){
						row = {
							item: segment.title + "- Incentives",
							n: segment.numberOfParticipants * segment.numberOfSessions,
							cpu: segment.incentive
						};
						rows.push(row)
					}
				})
				if( this.request.additionalCosts ){
					this.request.additionalCosts.forEach( cost => {
						row = {
							item: cost.name,
							n: cost.n,
							cpu: cost.cpu
						};
						rows.push(row)
					})
				}
				var total = 0;
				rows.forEach( row => {
					row.total = row.n * row.cpu;
					total += row.total
				})
				rows.push( {
					item: "Total", 
					total: total
				})
				return rows;
			},
		}
	}
</script>